import VFileDropPlugin from 'v-file-drop'
import 'v-file-drop/styles.css'

export default defineNuxtPlugin((nuxtApp) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    nuxtApp.vueApp.use(VFileDropPlugin as any, {
        multiple: true,
        accept: ['image/jpeg', 'image/png'],
    })
})
